import React from 'react'
import { useField } from 'formik'

interface SelectSelectedCountProps {
  formFieldUid: string
  /** true for CHECKBOX (array value); false for RADIO (single value) */
  multiple?: boolean
}

/**
 * The "{N} selected" count badge shown next to a select field's label (Figma:
 * label row = title + count badge + help icon). Reads the live Formik value so
 * the count stays in sync as choices are toggled.
 */
const SelectSelectedCount: React.FC<SelectSelectedCountProps> = ({ formFieldUid, multiple }) => {
  const [inputField] = useField(formFieldUid)
  const value = inputField.value
  const count = multiple
    ? Array.isArray(value)
      ? value.length
      : 0
    : value != null && value !== ''
      ? 1
      : 0

  return (
    <span
      className="sf-count-badge"
      data-test-id={`cs-asset-details-field-${formFieldUid}-selected-count`}
    >
      {count} selected
    </span>
  )
}

export default SelectSelectedCount
